import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const articles = document.querySelectorAll('.featured-carousel-swiper');
articles.forEach((articleElement, index) => {
    articleElement.classList.add(`featured-carousel-swiper-${index}`);

    // find the carousel-next and carousel-prev buttons and add index, these elements are up a level from the articleElement
    let carouselNext = articleElement.parentElement.querySelector('.carousel-next');
    let carouselPrev = articleElement.parentElement.querySelector('.carousel-prev');
    carouselNext.classList.add(`carousel-next-${index}`);
    carouselPrev.classList.add(`carousel-prev-${index}`);

    const swiper = new Swiper(`.featured-carousel-swiper-${index}`, {
        modules: [Navigation, Pagination],
        a11y: true,
        speed: 400,
        loop: false,
        centeredSlides: false,

        slidesPerView: 1.3,
        spaceBetween: 24,
        slidesOffsetAfter: 20,
        breakpoints: {
            500: {
                slidesPerView: 2,
                spaceBetween: 30,
                slidesOffsetAfter: 0
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
                slidesOffsetAfter: 0
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
                slidesOffsetAfter: 0
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 30,
                slidesOffsetAfter: 0
            }
        },
        slideClass: 'swiper-slide',
        navigation: {
            addIcons: false,
            nextEl: `.carousel-next-${index}`,
            prevEl: `.carousel-prev-${index}`
        },
        // pagination: {
        //     el: `.swiper-pagination-` + blockId,
        //     type: 'bullets',
        //     clickable: true
        // },
    });
});
